/**
 * Anchor Links
 *
 * This script is used to handle clicks on links with anchors and scroll to the corresponding
 * anchor or redirect to a different page if the link points to a different domain.
 */
const anchorLinks = document.querySelectorAll('a[href*="#"]:not([href="#"])');

// Helper function to get the value of a CSS variable in pixels
function getCSSVariableValue(varName) {
  const body = document.body;
  const value = getComputedStyle(body).getPropertyValue(varName).trim();
  
  if (value.endsWith('rem')) {
    const remValue = parseFloat(value); // Get the numeric value from rem
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize); // Get the root font size
    return remValue * rootFontSize; // Convert rem to pixels
  }

  return parseFloat(value); // For cases where the value is already in pixels or another unit
}

anchorLinks.forEach((link) => {
  link.addEventListener("click", (el) => {
    el.preventDefault();
    actionMenu.click();
    let target = el.target;
    let linkNode = target.nodeName === "A" ? target : target.parentNode;
    let href = linkNode.getAttribute("href");

    // Check if the href is only a hash (i.e., it doesn't contain a full URL)
    if (href.startsWith("#")) {
      let hash = href.slice(1);
      const element = document.getElementById(hash);

      if (!element) {
        console.error(`No element found with id "${hash}"`);
        return;
      }

      const offset = element.offsetTop;

      // Get the --navigationYOffset variable from CSS and subtract it from the offset
      const navigationYOffset = getCSSVariableValue('--navigationYOffset');

      window.scrollTo({
        top: offset - navigationYOffset,
        behavior: "smooth",
      });
    } else {
      const url = new URL(href, location.origin);
      const current_url = new URL(location.href);
      let hash = url.hash.slice(1);

      if (current_url.pathname !== url.pathname) {
        window.location = url;
      } else {
        const element = document.getElementById(hash);

        if (!element) {
          console.error(`No element found with id "${hash}"`);
          return;
        }

        const offset = element.offsetTop;

        // Get the --navigationYOffset variable from CSS and subtract it from the offset
        const navigationYOffset = getCSSVariableValue('--navigationYOffset');

        window.scrollTo({
          top: offset - navigationYOffset,
          behavior: "smooth",
        });
      }
    }
  });
});

window.addEventListener("load", function () {
  const current_url = new URL(location.href);

  if (window.location.hash) {
    let hash = current_url.hash.slice(1);
    const element = document.getElementById(hash);

    // Remove the hash from the URL
    history.replaceState("", document.title, window.location.pathname);

    if (element && element.nodeName === "FORM") {
      window.scrollTo({
        top: window.pageYOffset,
        behavior: "smooth",
      });
      return;
    }

    if (!element) {
      console.error(`No element found with id "${hash}"`);
      return;
    }

    const offset = element.offsetTop;

    // Get the --navigationYOffset variable from CSS and subtract it from the offset
    const navigationYOffset = getCSSVariableValue('--navigationYOffset');

    // Scroll to the anchor element
    window.scrollTo({
      top: offset - navigationYOffset,
      behavior: "smooth",
    });
  }
});

// Back to top functionality
const backToTopLink = document.querySelector('a.back[href="#"]');
if (backToTopLink) {
  // Toggle visibility based on scroll position
  window.addEventListener("scroll", function () {
    // Set threshold to one viewport height; adjust as needed (e.g., multiple of viewport height)
    const threshold = window.innerHeight;
    if (window.pageYOffset > threshold) {
      backToTopLink.classList.add("is-visible");
    } else {
      backToTopLink.classList.remove("is-visible");
    }
  });

  backToTopLink.addEventListener("click", (event) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}